// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5547":"3cee4e0587269003","7080":"4b2a273a72735e32"}[chunkId] + ".css";
};